import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";

import studentServices from "../../../services/studentServices";
import CustomModal from "../../CustomModal";
import LoadingSpinner from "../../LoadingSpinner";

const TrophiesAndBadgesModal = forwardRef(({}, ref) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [trophies, setTrophies] = useState([]);
  const [loading, setLoading] = useState(false);

  useImperativeHandle(ref, () => ({
    openModal() {
      setIsOpen(true);
    },
    closeModal() {
      setIsOpen(false);
    },
  }));

  const handleCloseModal = () => {
    setIsOpen(false);
  };

  const fetchStudentTrophies = async () => {
    setLoading(true);
    try {
      const response = await studentServices.getStudentTrophies();
      setTrophies(response);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      fetchStudentTrophies();
    }
  }, [isOpen]);

  return (
    <CustomModal
      isOpen={isOpen}
      onClose={handleCloseModal}
      className="max-w-5xl rounded-3xl border-8 border-blue-500 bg-[#F1F1F1] shadow-2xl"
      contentClassname="p-6 bg-[#F1F1F1]"
    >
      <div className="p-6 md:p-8">
        <h2 className="mb-6 text-center text-3xl font-extrabold text-blue-700">
          {t("your_trophies_and_badges")}
        </h2>

        <div className="mb-6">
          {loading ? (
            <div className="text-center text-gray-600">
              <LoadingSpinner />
            </div>
          ) : trophies.length === 0 ? (
            <div className="text-center text-gray-500">{t("no_trophies_yet")}</div>
          ) : (
            <div className="grid grid-cols-2 gap-6 sm:grid-cols-3 md:grid-cols-4">
              {trophies.map((trophy, index) => (
                <div
                  key={index}
                  className="flex flex-col items-center rounded-xl bg-white p-4 shadow-md transition-transform hover:scale-105 hover:shadow-xl"
                >
                  <img
                    src={trophy.image}
                    alt={trophy.name}
                    className="mb-2 h-24 w-24 rounded-lg object-cover"
                  />
                  <span className="text-center text-sm font-medium text-gray-700">{trophy.name}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </CustomModal>
  );
});

export default TrophiesAndBadgesModal;
